export enum FeatureEnum {
  QUICKBOOKS = 'quickbooks'
}

export const featureLabelList = {
  [FeatureEnum.QUICKBOOKS]: 'Quickbooks Desktop Connect'
}
